module.exports = __webpack_public_path__ + "img/地址.1e866f70.png";